import { IDataContextProvider } from "@refinedev/core/dist/contexts/data/IDataContext";
import { AxiosInstance } from "axios";

import { DataProvider } from "@refinedev/core";
import qs from "qs";
import axAPI from "../../../../api/axios-instance";
import { generateFilter } from "../../../../helpers";

export const mappingRusstatDataProvider = (
  apiUrl: string,
  httpClient: AxiosInstance = axAPI
): DataProvider =>
  <IDataContextProvider>{
    getList: async ({ resource, sort, meta, filters }) => {
      const url = "cms/rs/league/mapping/season";
      const queryFilters = generateFilter(filters);
      try {
        const { data, headers } = await httpClient.get(
          `${url}?${qs.stringify({ ...queryFilters })}`
        );
        return {
          data,
        };
      } catch (e) {
        return Promise.reject(e);
      }
    },
    create: async ({
      resource,
      meta,
      variables,
    }: {
      meta: {
        leagueId: string;
        fnlLeagueId: number;
        fnlSeasonId: number;
        rsLeagueId: number;
        rsSeasonId: number;
      };
      resource: string;
      variables: {
        rsLeagueId: number;
        rsSeasonId: number;
      };
    }) => {
      const url = "cms/rs/league/mapping/season";
      const { fnlLeagueId, fnlSeasonId: originSeasonId } = meta;
      try {
        await httpClient.post(url, {
          fnlLeagueId,
          fnlSeasonId: originSeasonId,
          ...variables,
        });

        return Promise.resolve();
      } catch (error: any) {
        return Promise.reject(error);
      }
    },
    custom: async ({ meta, url }) => {
      const { id } = meta as { id: number };

      const getUrl = `cms/rs/${url}`;

      const axiosResponse = await httpClient.get(getUrl);

      const { data } = axiosResponse;

      return Promise.resolve({ data });
    },
  };
